var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 75.73,
    height: 92.322,
    viewBox: "0 0 75.73 92.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Union_3",
    x: 0,
    y: 0,
    width: 75.73,
    height: 73.663,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Subtraction_3",
    x: 9.624,
    y: 53.012,
    width: 56.491,
    height: 39.31,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_356_20",
    "data-name": "Component 356 \\u2013 20",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Union_3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_3-2",
    "data-name": "Union 3",
    d: "M22.914,53.44a8.719,8.719,0,0,1-6.374-.387,8.136,8.136,0,0,1-4.408-4.413,8.473,8.473,0,0,1-5.609-2.917,7.756,7.756,0,0,1-2.04-5.778A8.032,8.032,0,0,1,.69,35.034,7.655,7.655,0,0,1,1.4,28.976,7.684,7.684,0,0,1,.143,23,7.923,7.923,0,0,1,3.47,17.793a7.685,7.685,0,0,1,1.5-5.926,8.4,8.4,0,0,1,5.321-3.375,8.047,8.047,0,0,1,3.987-4.762,8.262,8.262,0,0,1,7.693-.382L22,3.342A8.048,8.048,0,0,1,28.865,0a8.58,8.58,0,0,1,5.952,2.223,8.72,8.72,0,0,1,6.373.383A8.137,8.137,0,0,1,45.6,7.022,8.481,8.481,0,0,1,51.207,9.94a7.755,7.755,0,0,1,2.04,5.779,8.029,8.029,0,0,1,3.792,4.91,7.646,7.646,0,0,1-.711,6.058,7.677,7.677,0,0,1,1.26,5.977A7.925,7.925,0,0,1,54.26,37.87a7.686,7.686,0,0,1-1.5,5.925,8.392,8.392,0,0,1-5.321,3.374,8.052,8.052,0,0,1-3.987,4.764,8.273,8.273,0,0,1-7.711.372,8.044,8.044,0,0,1-6.874,3.357A8.577,8.577,0,0,1,22.914,53.44Z",
    transform: "translate(9 6)",
    fill: "#3c617d"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 20.619,
    cy: 20.619,
    r: 20.619,
    transform: "translate(8.248 7.953)",
    fill: "#f5f5f8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Subtraction_3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3-2",
    "data-name": "Subtraction 3",
    d: "M38.491,21.31H38.1l-9.232-3.162V4.24c.746-.154,1.478-.329,2.177-.52,3.39-.927,5.966-2.211,7.449-3.716v21.3h0ZM.4,21.31H0V0C1.479,1.5,4.055,2.789,7.45,3.718c.695.19,1.425.365,2.17.519V18.151Zm14.721-5.042h0V5.008c1.348.107,2.738.162,4.13.162s2.771-.054,4.117-.161V16.265l-4.12-1.411L15.12,16.268Z",
    transform: "translate(18.62 59.01)",
    fill: "#3c617d"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": 4,
    transform: "translate(16.654 42.285)",
    fill: "#3c617d",
    fontSize: 39,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverBadge);
export default __webpack_public_path__ + "static/media/silver-badge.5b5063d349a0e69af1f99803b4f74542.svg";
export { ForwardRef as ReactComponent };